import { Tree } from 'element-ui'

const YTree = Tree
YTree.$depends = [Tree]
YTree.$name = 'y-tree'
YTree._name = 'Tree 树形控件'

export default YTree
